import { TListTemplateModel, TSenderModel, TTemplateModel } from "@cakemail-org/ui-components-v2"

export type TSystemEmailsTable = {
    loading?: boolean,
    reloadTable: Function
}

export enum ESystemEmailType {
    accountConfirm = "account_confirm",
    userConfirm = "user_confirm",
    senderConfirm = "sender_confirm",
    passwordReset = "password_reset",
    contactDOptIn = "contact_double_opt_in",
}
